export * as schemas from "./gen/schemas.gen";
export * as types from "./gen/types.gen";

import type { Client } from "@hey-api/client-fetch";
import * as services from "./gen/services.gen";
import { useClient } from "./client";

// eslint-disable-next-line
type ServiceFunction<T> = T extends (options: infer O) => any
    ? O extends { client?: Client }
        ? (options: Omit<O, "client">) => ReturnType<T>
        : T
    : T;

type Services = Omit<
    {
        [K in keyof typeof services]: ServiceFunction<(typeof services)[K]>;
    },
    "client"
>;

/**
 * Use the services with our own client.
 */
export const useServices = ({
    opts,
    requires,
}: {
    opts?: {
        throwOnError: boolean;
    };
    requires: {
        auth: boolean;
        organization: boolean;
        stek: boolean;
    };
}): Services => {
    const client = useClient({ requires });

    // Set default values for opts.
    if (!opts) {
        opts = { throwOnError: true };
    }
    if (opts?.throwOnError === undefined) {
        opts.throwOnError = true;
    }

    return Object.fromEntries(
        Object.entries(services as Services).map(([key, service]) => [
            key,
            // eslint-disable-next-line
            (options: any) => service({ client, ...opts, ...options }),
        ])
    ) as Services;
};

/**
 * Default services.
 */
export const api = useServices({
    requires: {
        auth: true,
        organization: true,
        stek: true,
    },
});
